import React from "react";
import { PhoneIcon, PhoneXMarkIcon } from "@heroicons/react/24/outline";
import { useCall } from "../../contexts/CallContext";

const CallButton = ({ calleeId, binId, calleeName, className = "", variant = "primary" }) => {
  const { callStatus, initiateCall, endCall } = useCall();

  const isInCall =
    callStatus === "requesting" ||
    callStatus === "ringing" ||
    callStatus === "ongoing";

  const handleClick = () => {
    if (isInCall) {
      endCall();
    } else {
      initiateCall(calleeId, binId, calleeName);
    }
  };

  const baseClasses =
    "inline-flex items-center justify-center font-medium rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2";

  const variantClasses = {
    primary:
      "bg-green-600 hover:bg-green-700 text-white focus:ring-green-500 disabled:bg-gray-400",
    secondary:
      "bg-white hover:bg-gray-50 text-gray-700 border border-gray-300 focus:ring-green-500",
    icon: "p-2 rounded-full bg-green-100 hover:bg-green-200 text-green-700 focus:ring-green-500",
  };

  if (variant === "icon") {
    return (
      <button
        onClick={handleClick}
        disabled={callStatus === "requesting"}
        className={`${baseClasses} ${variantClasses.icon} ${className}`}
        title={isInCall ? "End call" : "Call"}
      >
        {isInCall ? (
          <PhoneXMarkIcon className="h-5 w-5 text-red-600" />
        ) : (
          <PhoneIcon className="h-5 w-5" />
        )}
      </button>
    );
  }

  return (
    <button
      onClick={handleClick}
      disabled={callStatus === "requesting"}
      className={`${baseClasses} ${variantClasses[variant] || variantClasses.primary} py-3 px-4 ${className}`}
    >
      {isInCall ? (
        <>
          <PhoneXMarkIcon className="h-5 w-5 mr-2" />
          {callStatus === "ongoing" ? "End Call" : "Calling..."}
        </>
      ) : (
        <>
          <PhoneIcon className="h-5 w-5 mr-2" />
          Call
        </>
      )}
    </button>
  );
};

export default CallButton;
